import { gql } from '@apollo/client';
const GET_ORDER_PENDING_APPROVAL_DELIVERIES = gql `
  query GetOrderPendingApprovalDeliveries($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        pendingApprovalDeliveries {
          id
          deliveryType
          quantityPlanned
          plannedDate
          orderComponentVariant {
            id
            name
            color
          }
        }
      }
    }
  }
`;
export default GET_ORDER_PENDING_APPROVAL_DELIVERIES;
